<template>
    <div class="box">
        <el-button type="primary" icon="el-icon-plus" @click="add">新建</el-button>
        <!-- 表格 -->
        <div class="tab">
            <el-table :data="tableData" style="width: 100%;" border v-loading="loading" element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading" :header-row-style="{ 'font-weight': 'bold', 'color': '#9196A0' }">

                <el-table-column prop="name" label="银行名称">
                </el-table-column>
                <el-table-column prop="imageUrl" label="图片">
                    <template slot-scope="{ row }">
                        <!-- <img :src="row.imageUrl" alt="" style="width: 60%; height: 60%;"> -->
                        <img v-img-url="hasImages(row.imageUrl)" alt="" width="50px" />
                    </template>
                </el-table-column>
                <el-table-column prop="sort" label="排序">
                </el-table-column>

                <el-table-column prop="createTime" label="创建时间">
                </el-table-column>
                <el-table-column label="操作" prop="id">
                    <template slot-scope="scope">
                        <el-link :underline="false" type="primary" @click="editbank(scope.row)">编辑</el-link>
                        <el-link :underline="false" type="danger" @click="delbank(scope.row.id)">删除</el-link>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页 -->
        <div class="paginationBox">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage4" :page-sizes="[10, 20, 30, 40]" :page-size="10"
                layout="total, sizes, prev, pager, next, jumper" :total="total" class="pagination">
            </el-pagination>
        </div>
        <AddView :message="dialogFormVisible" @closeFunction='getDialogFormVisible' @add-success="bankListFunc"
            :itemList="itemValue">
        </AddView>
    </div>
</template>

<script>
import AddView from './components/AddView.vue';
import bankApi from '@/api/setting/bank.js';
export default {
    data() {
        return {
            tableData: [],
            total: 0, // 总数
            currentPage4: 1,
            dialogFormVisible: false,
            loading: true, // 表格加载
            pageSize: 10, // 每页显示多少条数据
            itemValue: null,
        }
    },
    components: { AddView },
    methods: {
        hasImages(e) {
            if (e) {
                return e;
            } else {
                return '';
            }
        },
        editbank(row) {
            this.itemValue = row;
            this.dialogFormVisible = true;
        },
        // 版本列表
        bankListFunc(pageSize) {
            this.loading = true
            bankApi.getBankList({ page: 1, pageSize: pageSize }).then(response => {
                if (response.data) {
                    this.total = response.data.total
                    this.tableData = response.data.records;
                }
                this.loading = false
            }).catch(error => {
                // console.error(error);
                this.loading = false
            });
        },
        // 每页显示多少条数据
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
            // this.pageSize = val;
            this.bankListFunc(val);
        },
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
        },
        // 新增
        add() {
            this.itemValue = {}
            this.dialogFormVisible = true;
        },
        getDialogFormVisible(value) {
            this.itemValue = null;
            this.dialogFormVisible = value;
        },
        // 删除
        delbank(id) {
            this.$confirm('此操作将永久删除此条信息, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                bankApi.getDelBank({ id: id }).then(res => {
                    if (res.errCode === 200) {
                        this.bankListFunc();
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                    }
                }).catch(err => {
                    console.log(err);
                })
            })
        },
    },
    mounted() {
        this.bankListFunc();
    },
}
</script>

<style scoped>
.tab {
    margin-top: 30px;
}
</style>


// WEBPACK FOOTER //
// src/views/setting/bank/index.vue